import { initializeApp } from "firebase/app";
// import { getFirestore } from "firebase/firestore";
// import { getStorage } from "firebase/storage";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getMessaging } from "firebase/messaging";

const APIKEY = process.env.REACT_APP_FIREBASE_API_KEY;
const AUTH_DOMAIN = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
const APPID = process.env.REACT_APP_FIREBASE_APP_ID;

const firebaseConfig = {
  apiKey: APIKEY,
  authDomain: AUTH_DOMAIN,
  projectId: "webnadinelogistics",
  storageBucket: "webnadinelogistics.appspot.com",
  messagingSenderId: "947416820806",
  appId: APPID,
  measurementId: "G-3T2KBS7TP5",
};
const app = initializeApp(firebaseConfig);
const Googleprovider = new GoogleAuthProvider();
const auth = getAuth(app);
//  const db = getFirestore(app);
//  const storage = getStorage(app);
const messaging = getMessaging(app);

export { auth, Googleprovider, messaging };
